export const BEHAVIOUR = {
  MANDATORY: 'MANDATORY',
};

export const LANGUAGES = {
  ENGLISH: 'english',
  SPANISH: 'spanish',
  BILINGUAL: 'bilingual',
};

export const ACTION_CODES = {
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
};

export const CONTEXT = {
  KIOSK: 'kiosk',
};

export const POST_MESSAGE_TYPES = {
  CLICK: 'click',
};

export const TIMER_DURATION = 20000;
